import { View, Text, StyleSheet, Linking } from 'react-native'
import { Image } from 'expo-image'
import { router } from 'expo-router'
import { StandaloneWrapper } from '@/src/common/wrappers/StandaloneWrapper'
import { mesaColorNames, typography } from '@/src/common/theme'
import { Button } from '@/src/common/components/Button'
import { Input } from '@/src/common/components/Input'
import { DesignSystem } from '@/src/design-system'
import { useState } from 'react'
import { Check } from '@/src/assets/icons/Check'
import * as Stores from '../stores'
import * as Navigation from '../navigation'
import * as Statsig from '../statsig'

export function PointsTransferScreen() {
  const [memberId, setMemberId] = useState('')
  const { setSelectedGuestId, selectedGuestId } = Stores.usePointsToOmniStore()
  const { dynamicConfig } = Statsig.DynamicConfig.useOmniPointsTransferDynamicConfig()

  const handleContinue = () => {
    if (!memberId.trim()) {
      return
    }
    setSelectedGuestId(memberId.trim())
  }

  const handleTransferPoints = () => {
    router.push(Navigation.Routes.TransferConfirmation.route)
  }

  const handleJoinSelectGuest = () => {
    void Linking.openURL(dynamicConfig?.value.registrationLink ?? '')
  }

  return (
    <StandaloneWrapper
      screen={Navigation.Routes.PointsTransfer.route}
      title="Omni Hotels & Resorts"
      profileProps={{ menuIconProps: { color: mesaColorNames['Mesa - Brand/White #FFFFFF'] } }}
      hideBackButton={false}
    >
      <View style={styles.container}>
        <DesignSystem.SplitCard>
          <DesignSystem.SplitCard.ImageHeader containerStyle={{ height: 180 }}>
            <Image
              source={require('@/src/assets/images/omni_header.png')}
              contentFit="cover"
              style={{ height: 180 }}
            />
          </DesignSystem.SplitCard.ImageHeader>
          <DesignSystem.SplitCard.Content>
            <View style={styles.cardContent}>
              <Text style={typography['heading/heading3']}>Omni Hotels & Resorts</Text>
              <Text style={[typography['S'], styles.description]}>
                Join Select Guest and get a free night stay* at any Omni destination for 100 Omni
                Credits.
              </Text>

              <View style={styles.benefitsList}>
                <View style={styles.benefitItem}>
                  <Check />
                  <Text style={[typography['label/sm-regular'], styles.benefitText]}>
                    Where you can use your Mesa Points with Omni:
                  </Text>
                </View>
                <View style={styles.benefitItem}>
                  <Check />
                  <Text style={[typography['label/sm-regular'], styles.benefitText]}>
                    Omni La Costa Resort & Spa in Carlsbad, CA
                  </Text>
                </View>
                <View style={styles.benefitItem}>
                  <Check />
                  <Text style={[typography['label/sm-regular'], styles.benefitText]}>
                    The Omni Grove Park Inn & Spa in Asheville, NC
                  </Text>
                </View>
                <View style={styles.benefitItem}>
                  <Check />
                  <Text style={[typography['label/sm-regular'], styles.benefitText]}>
                    Omni Parker House in Boston, MA
                  </Text>
                </View>
                <View style={styles.benefitItem}>
                  <Check />
                  <Text style={[typography['label/sm-regular'], styles.benefitText]}>
                    Omni Frisco Hotel at the Star in Texas & more
                  </Text>
                </View>
              </View>

              {selectedGuestId ? (
                // After ID is set, show only Transfer Points button
                <View style={styles.actionSection}>
                  <Button title="Transfer Points" onPress={handleTransferPoints} />
                </View>
              ) : (
                // Before ID is set, show ID input and confirm button
                <View style={styles.actionSection}>
                  <Input
                    label="Select Guest Member ID"
                    value={memberId}
                    onChangeText={setMemberId}
                    placeholder="A1B2C3"
                    autoCapitalize="characters"
                  />

                  <Button
                    title="Confirm Select Guest ID"
                    onPress={handleContinue}
                    disabled={!memberId.trim()}
                  />

                  <View style={styles.joinButton}>
                    <Text style={[typography['label/md-bold'], styles.joinButtonText]}>
                      Not a Member?{' '}
                      <Text style={styles.joinButtonLink} onPress={handleJoinSelectGuest}>
                        Join
                      </Text>{' '}
                      Select Guest Today
                    </Text>
                  </View>
                </View>
              )}
            </View>
          </DesignSystem.SplitCard.Content>
        </DesignSystem.SplitCard>

        <View style={styles.termsSection}>
          <Text style={[typography['S'], styles.termsTitle]}>
            *Points Transfer Terms & Conditions
          </Text>
          <Text style={[typography['S'], styles.termsText]}>
            Enrollment in the Partner's Program is required. Mesa is not responsible for the
            availability of hotel rooms or airline seats in the Partner's Program. You, as a
            Transferer, should check award availability and your eligibility before transferring
            points.
          </Text>
          <Text style={[typography['S'], styles.termsText]}>
            Once you transfer, Mesa Points cannot be reversed or transferred back into your Mesa
            account. They become subject to the Partner Program Terms and Conditions. Omni Transfers
            may take up to 7 business days to process. Points do not cover taxes and fees, therefore
            charges may apply, and are the sole responsibility of the Transferer. All redemption
            bookings are governed by the Partner's Program Terms and Conditions.
          </Text>
          <Text style={[typography['S'], styles.termsText]}>
            A minimum transfer amount may apply. Refer to the Partner's transfer policy for details.
            Once a transfer request is submitted, it cannot be canceled, modified, or reversed.
            Please review all details before confirming a transfer.
          </Text>
          <Text style={[typography['S'], styles.termsText]}>
            The name on your Mesa account must match the name on your Partner Program account.
            Transfers to third-party accounts are not permitted. Once transferred, points are
            subject to the valuation and redemption policies of the Partner's Program.
          </Text>
          <Text style={[typography['S'], styles.termsText]}>
            Mesa reserves the right to suspend or terminate points transfers in cases of suspected
            fraud, abuse, or misuse. Additionally, Mesa reserves the right to modify, suspend, or
            terminate the points transfer program at any time, with or without notice, including but
            not limited to changes in transfer eligibility, limits, or Partner participation.
            Participation in the points transfer program is subject to all applicable laws and
            regulations. Mesa may restrict, suspend, or terminate participation in jurisdictions
            where such transfers are not permitted by law. Any disputes related to the transfer of
            Mesa Points shall be resolved in accordance with Mesa's general Terms and Conditions,
            including applicable arbitration or dispute resolution provisions.
          </Text>
          <Text style={[typography['S'], styles.termsText]}>
            Transfer limits may apply per transaction, per day, per month, or annually. Processing
            times may vary, and delays beyond Mesa's control may occur. Mesa is not responsible for
            lost, misdirected, or delayed point transfers. Mesa is not responsible for the actions,
            omissions, or policies of any Partner's Program, including but not limited to reward
            availability, program changes, devaluation of points, or account restrictions imposed by
            the Partner.
          </Text>
        </View>
      </View>
    </StandaloneWrapper>
  )
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    gap: 24,
  },
  cardContent: {
    gap: 16,
  },
  description: {
    color: mesaColorNames['global/grey/80 #2F3133'],
  },
  benefitsList: {
    gap: 8,
  },
  benefitItem: {
    flexDirection: 'row',
    alignItems: 'flex-start',
    gap: 8,
  },
  benefitText: {
    color: mesaColorNames['global/grey/80 #2F3133'],
    flex: 1,
  },
  actionSection: {
    gap: 16,
    marginTop: 8,
  },
  joinButton: {
    alignItems: 'center',
  },
  joinButtonText: {
    color: mesaColorNames['global/grey/80 #2F3133'],
    textAlign: 'center',
  },
  joinButtonLink: {
    color: mesaColorNames['Mesa Primary Scale/400 - Brand #00DFC9'],
  },
  termsSection: {
    gap: 12,
  },
  termsTitle: {
    color: mesaColorNames['Mesa - Brand/White #FFFFFF'],
    fontWeight: '600',
  },
  termsText: {
    color: mesaColorNames['Mesa - Brand/White #FFFFFF'],
    lineHeight: 18,
  },
})
